module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/icon_sns-33e7e10d818d040e94c3c8c3b93a1097.png";